var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('myHeader'),_vm._v(" "),_c('div',{staticClass:"web-body"},[_c('div',{staticClass:"about"},[_c('my-banner',{attrs:{"Mytype":'recruitment'}})],1)]),_vm._v(" "),_c('myFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62142c72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recruitment.vue
// module id = null
// module chunks = 